import { render } from "./BillingReceipt.vue?vue&type=template&id=cc240e0e&scoped=true"
import script from "./BillingReceipt.vue?vue&type=script&lang=js"
export * from "./BillingReceipt.vue?vue&type=script&lang=js"

import "./BillingReceipt.vue?vue&type=style&index=0&id=cc240e0e&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc240e0e"]])

export default __exports__